<template>
	<div style="overflow: hidden; min-height: 600px;">
		<div class="collection-block">
			<div class="collection-main">
				<div class="collection-box" v-for="(item, index) in newsList" :key="index" @click="toDetails(item.id)">
					<img :src="$imgUrl + item.listImgPc" alt="">
					<div class="title-box">
						{{item.title}}
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getDataList" ref="page"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data () {
			return {
				params: {
					current: 1,
					size: 18,
					releaseTerrace: "releasePc",
					channelId: 92
				},
				newsList: [],
			}
		},
		mounted() {
			let that = this
			that.$store.state.firstSelect = ''
			that.$store.state.secondSelect = ''
			that.$store.state.secondList = []
			that.$store.state.channelId = ''
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../../static/search_top.png'
		},
		methods: {
			getDataList(dataList, count) {
				this.newsList = dataList
			},
			toDetails(news_id) {
				this.$router.push({
					path: '/news_video_details',
					query: {
						news_id: news_id
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.search-box {
		width: 100%;
		height: 45px;
		background-color: #D0DEFD;
		display: flex;
		.search-button {
			width: 90px;
			height: 30px;
			line-height: 30px;
			margin: 7px 0 0 15px;
			background-color: #264EA7;
			color: #FFFFFF;
			font-size: 14px;
			cursor: pointer;
		}
	}
	.collection-block {
		width: 74%;
		margin: 0 13%;
		padding: 20px 0 40px;
		.collection-main {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.collection-box {
				width: 32%;
				margin: 5px 0.5%;
				height: auto;
				cursor: pointer;
				position: relative;
				img {
					width: 100%;
					height: 100%;
				}
				.title-box {
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					padding: 0 5%;
					height: 26px;
					line-height: 26px;
					font-size: 14px;
					color: #FFFFFF;
					background-color: rgba(0, 0, 0, 0.7);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					text-align: center;
				}
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/views/news_video/news_video.vue